import httpClient from "../lib/HttpClient";

class Chat {
  constructor() {}

  // Get all sessions for current user
  getSessions = () => {
    return httpClient.get("/chat_sessions");
  };

  // Get sessions for a specific document
  getSessionsForDocument = (documentId) => {
    return httpClient.get(`/documents/${documentId}/chat_sessions`);
  };

  // Get sessions for a specific library
  getSessionsForLibrary = (libraryId) => {
    return httpClient.get(`/libraries/${libraryId}/chat_sessions`);
  };

  // Get a single session with all messages
  getSession = (sessionId) => {
    return httpClient.get(`/chat_sessions/${sessionId}`);
  };

  // Create a new session
  createSession = () => {
    return httpClient.post("/chat_sessions", {});
  };

  // Update session (e.g., rename title)
  updateSession = (sessionId, data) => {
    return httpClient.put(`/chat_sessions/${sessionId}`, {
      chat_session: data,
    });
  };

  // Delete a session
  deleteSession = (sessionId) => {
    return httpClient.delete(`/chat_sessions/${sessionId}`);
  };

  // Send a message and get AI response
  sendMessage = (sessionId, query, context) => {
    return httpClient.post(`/chat_sessions/${sessionId}/messages`, {
      query,
      context,
    });
  };
}

export default new Chat();
